import React from "react";

export default function ClubPresidentFields({ f, setF }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-4 border-t border-zinc-800">
            <div>
                <label className="label-tu">Nom du président</label>
                <input
                    data-testid="admin-club-president-name"
                    value={f.president_name}
                    onChange={(e) => setF({ ...f, president_name: e.target.value })}
                    className="input-tu"
                />
            </div>
            <div>
                <label className="label-tu">Téléphone du président</label>
                <input
                    data-testid="admin-club-president-phone"
                    value={f.president_phone}
                    onChange={(e) => setF({ ...f, president_phone: e.target.value.replace(/[^0-9 .\-]/g, "") })}
                    placeholder="06 12 34 56 78"
                    className="input-tu"
                />
            </div>
        </div>
    );
}
